export default "__VITE_ASSET__1107e6ce__"